class Fullscreen {
  static get enabled() {
    return !!(document.fullscreenElement || document.webkitFullscreenElement);
  }

  /**
   * @param {HTMLElement} element
   * @return {Promise<unknown>}
   */
  static enter(element) {
    return this.promisify(element.requestFullscreen || element.webkitRequestFullscreen, [element]);
  }

  /**
   * @return {Promise<unknown>}
   */
  static exit() {
    return this.promisify(document.exitFullscreen || document.webkitExitFullscreen, [document]);
  }

  /**
   * @param {Function} fn
   * @param {Array<Object>} args
   * @return {Promise<unknown>}
   */
  static promisify(fn, args = []) {
    return new Promise((resolve, reject) => {
      if (!fn) {
        return reject(new Error('no Fullscreen API available'));
      }

      const result = fn.call(...args);
      if (result instanceof Promise) {
        return result.then(resolve, reject);
      }

      resolve(result);
    });
  }
}

export default Fullscreen;
